import { Button, List, Section } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

type Props = {
  id: string
  name: string
}

const PermissionGroupInformation = ({ id, name }: Props) => {
  const { navigation } = useNavigation()

  return (
    <Section
      title={i18n.t('employee_form.permission_group.title')}
      description={i18n.t('employee_form.permission_group.description')}
      illustration="group"
    >
      <List>
        <List.Item>
          <List.Title ellipsis>{name}</List.Title>
          <Button.Router
            to={navigation.settings.permissions.id.fullPath({ id: id })}
            type="secondary"
            iconName="arrow-right"
          />
        </List.Item>
      </List>
    </Section>
  )
}

export default PermissionGroupInformation
